import type { BaseEditor } from 'slate';
import type { StateEnum } from '@halo/chat-sdk';
import type { EmptyElement } from '../../types';

export interface MentionUser {
  user_id: string;
  username: string;
  name: string;
  avatar: string;
  original_name: string;
  remark_name: string;
  state: StateEnum;
}

export interface MentionEditor extends BaseEditor {
  insertMention: (user: MentionUser) => void;
}

export const MentionElementType = 'mention';

export interface MentionElement extends EmptyElement {
  type: typeof MentionElementType;
  user: MentionUser;
}

export interface MentionPortalContextProps {
  disabled?: boolean;
  onOpenChange?: (open: boolean) => void;
  filterUsers: (search: string) => Promise<MentionUser[]>;
  canAtAll?: boolean;
}

export interface MentionElementContextProps {
  onClick?: (user: MentionUser) => void;
}

export interface MentionContextProps {
  portal: MentionPortalContextProps;
  element: MentionElementContextProps;
}
